module.exports = __webpack_public_path__ + "static/media/arrow-left-circle-disabled.26b78904.png";